export default __webpack_public_path__ + "static/media/creditCardWhite.7e8cbc88.svg";